'use client';
import { useConversationContext, useMessageContext } from '@ui/components';
import { BaseMessageInput } from './base-message-input';

export const ConversationMessageInput = () => {
  const state = useConversationContext();
  const messageState = useMessageContext('creator');

  const handleCancelReply = () => {
    messageState.setReplyToMessage?.(null);
  };

  return (
    <BaseMessageInput
      onCreateMessage={messageState.onCreateMessage}
      onUpdateMessage={messageState.onUpdateMessage}
      selectedThread={state.selectedConversationSet?.conversation.main_thread}
      creatorId={state.creator_id}
      user_id={messageState.user_id}
      user_username={messageState.user_username}
      messageToEdit={messageState.messageToEdit}
      setMessageToEdit={messageState.setMessageToEdit}
      replyToMessage={messageState.replyToMessage}
      onCancelReply={handleCancelReply}
      onSetOnboardingTriggerVisibility={messageState.onSetOnboardingTriggerVisibility}
      isCreating={messageState.isCreating}
      isPostingImage={messageState.isPostingImage}
      query={messageState.query}
      shouldSendEmail={true}
      created_by_creator={messageState.created_by_creator}
    />
  );
};
